import * as d3 from 'd3'
export default {
  
  methods: {

    setDefaultValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      let sql1 = JSON.parse(JSON.stringify(this.Queries.SQL1[0]))
      this.summarytData = JSON.parse(JSON.stringify(this.Queries.SQL2))

      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.codes    = json.codes
      this.summary  = json.summary
      this.area     = json.area
      this.sheet    = json.sheet
      this.punch    = json.punch
      this.legend   = json.legend
      this.detail   = json.detail

      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries

      // Search
      this.search = {...json.search,
        targets : [''],
        input   : '',
        results : [],
      }
      
      // Timeline
      this.timeline = {...json.timeline,
        cutoff    : sql1.CUTOFF,
        weekEnd   : sql1.WEEKEND,
        startDate : sql1.START,
        endDate   : sql1.END,
        refColumn : this.codes.timeline,
      }

      // Skyline
      this.skyline = {...json.skyline,
        main     : sql1.MAIN,
        sub      : sql1.SUB,
        data     : []
      }

      this.gmx_tableCoordinates('x', this.summary.cols, 3)

      this.current = {area: 'OVERALL', sheet: 'NONE', punch: 'NONE',}

      // Filtering Data
      this.reflash_DataSet() // ----->
      this.set_SkylineData() // ---> below

    },

    set_SkylineData() {
      this.gmx_SkylineValues_Week(this.skyline.data.filter(f => f.EXCEPT != 'Y'))

      this.skyline.data.forEach(d => {
        let date__  = this.gmx_setTimelineCDate(d[this.timeline.refColumn])
        let sht = this.sheet.find(f=> f.code == d[this.codes.status])
        
        if(d.EXCEPT != 'Y') {
          d.cDate  = date__.eDate
          d.sDate  = date__.sDate
        }
        d.date   = d3.timeParse('%Y-%m-%d')(d[this.timeline.refColumn])
        d.tSize  = this.skyline.tSize
        d.bColor = sht.color
        d.stroke = sht.stroke
        d.sWidth = sht.sWidth
        d.opacity = sht.opacity

        if(d.TURNOVER == 'Y') {
          d.stroke = '#F35E90'
          d.sWidth = 1.5
        }

      })
    },

  }
}